import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext,} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import WorkspaceContext from "../../WorkspaceContext";
import {formatNumber} from "../../../../helpers/number";
import {Avatar} from "antd";
import {FaBoxOpen, FaChalkboard} from "react-icons/fa6";
import {useShopForm} from "../../../AppLocals/Shop/functions/useShopForm";
import CRUD from "../../../Shared/enums/CRUD";
import {IoStorefront} from "react-icons/io5";
import ShopContainer from "./ShopContainer";
import {ShoppingFilled} from "@ant-design/icons";
import {ShoppingIconSvg} from "../../../../components/Svgs/ShoppingIconSvg";

const StatCard = ({title, value, secondary_value, color, icon, style, href}) => {
    const t = useTranslate()
    return (
        <Link
            to={href}
            style={{
                boxShadow: '0 2px 4px 0px rgba(0, 0, 0, 0.15)',
                ...style
            }}
            className="px-4 py-3 flex items-center border border-color-50 background shadow-md rounded-xl no-underline relative">
            <div className="flex flex-col flex-1">
                <p className="font-medium text-sm text-color-300 tracking-wider">{title}</p>
                <div className="mt-1 flex items-baseline gap-1">
                    {value ? (
                        <p className="text-2xl font-bold text-gray-900 tracking-wide">
                            {value}
                        </p>
                    ) : (
                        <p className="text-sm text-color-500 italic tracking-wider leading-9">
                            {t('no data yet')}
                        </p>
                    )}
                    {!!secondary_value && (
                        <p className="text-base font-medium text-color-500 tracking-wide">{` / ${secondary_value}`}</p>
                    )}
                </div>
            </div>
            <div style={{ top: 8, right: 8 }} className="absolute">
                <Avatar
                    size={40}
                    className={`flex flex-center bg-${color}-100 opacity-60`}
                    icon={icon}
                />
            </div>
        </Link>
    )
};


const ShopDashboard = ({
                           owner_id,
                           owner_type,
                           filter_actions = {
                               sortBy: 'sort-by',
                               keyword: 'keyword',
                           },
                       }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);

    const {
        modal: shopModal,
        handleAction: handleShopAction,
        onCancel: onShopCancel,
    } = useShopForm({organization})

    return (
        <div className="flex flex-col flex-1 gap-y-3">
            <div className="mb-6 flex flex-col gap-4">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('overview')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
                {/*<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">*/}
                {/*    <StatCard*/}
                {/*        title={t('total shops')}*/}
                {/*        value={formatNumber(organization?.workspace_settings?.shops?.statistics?.shop_count)}*/}
                {/*        color="indigo" icon={<IoStorefront size={20} className="text-secondary"/>}*/}
                {/*        // href={`/workspace/shop?rel=shops`}*/}
                {/*    />*/}
                {/*    <StatCard*/}
                {/*        title={t('total products')}*/}
                {/*        value={formatNumber(organization?.workspace_settings?.shops?.statistics?.product_count)}*/}
                {/*        color="orange" icon={<FaBoxOpen size={20} className="text-orange-500"/>}*/}
                {/*        // href={`/workspace/shop?rel=shops`}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-4">
                        <StatCard
                            title={t('total shops')}
                            value={formatNumber(organization?.workspace_settings?.shops?.statistics?.shop_count)}
                            color="indigo" icon={<IoStorefront size={20} className="text-secondary"/>}
                            // href={`/workspace/shop?rel=shops`}
                        />
                        <StatCard
                            title={t('total products')}
                            value={formatNumber(organization?.workspace_settings?.shops?.statistics?.product_count)}
                            color="orange" icon={<FaBoxOpen size={20} className="text-orange-500"/>}
                            // href={`/workspace/shop?rel=shops`}
                        />
                    </div>
                    <div
                        style={{
                            boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)',
                            borderRight: '1px solid var(--border-color-50)',
                        }}
                        className="p-6 flex flex-col background rounded-xl shadow-lg border-l-4 border-indigo-500">
                        <h3 className="mb-3 flex items-center text-xl font-bold text-gray-800 tracking-wide">
                            <ShoppingIconSvg size={20} className="mr-2 text-indigo-500"/>
                            {t('initialize shop')}
                        </h3>
                        <p className="flex-1 mb-4 text-color-300 tracking-wider">
                            {t("start setting up your new training content")}
                        </p>
                        <button
                            onClick={() => {
                                handleShopAction(CRUD.CREATE)
                            }}
                            className="w-full px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-700 transition font-medium">
                            + {t("create shop")}
                        </button>
                    </div>
                </div>
            </div>
            <ShopContainer />
            {shopModal}
            <div className="h-16"/>
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(ShopDashboard)
